// Mock data for Resurge consulting website

export const services = [
  {
    id: 1,
    title: 'Business Rebuild & Clarity Sprint',
    description: 'Short, intense engagement to identify what\'s actually broken, cut waste, reset priorities, and rebuild around cashflow & execution.',
    icon: 'Target',
    outcomes: [
      'Clear operating model',
      'Revenue focus',
      'Execution roadmap',
      'Waste elimination'
    ]
  },
  {
    id: 2,
    title: 'Marketplace Strategy & Scale',
    description: 'For Amazon, Back Market, Refurbed, Noon, etc. Pricing logic, stock strategy, refund/fraud reduction, operational flow, and scaling without chaos.',
    icon: 'TrendingUp',
    outcomes: [
      'Pricing optimization',
      'Fraud reduction',
      'Dispute handling',
      'Clean scaling'
    ]
  },
  {
    id: 3,
    title: 'E-commerce & Brand Launch',
    description: 'Done-with-you execution for founders with product, stock, or capital. Shopify setup, offer clarity, funnels, and operational backend.',
    icon: 'ShoppingBag',
    outcomes: [
      'Store setup',
      'Offer clarity',
      'Sales funnels',
      'Backend operations'
    ]
  },
  {
    id: 4,
    title: 'Fraud, Leakage & Risk Advisory',
    description: 'Device fraud, returns abuse, proof-of-delivery systems, and operational blind spots. Direct experience preventing losses at scale.',
    icon: 'Shield',
    outcomes: [
      'Fraud prevention',
      'Returns optimization',
      'Verification systems',
      'Risk mitigation'
    ]
  },
  {
    id: 5,
    title: 'Founder Transition & Exit Support',
    description: 'For operators leaving jobs, partnerships, or legacy businesses. Restructure income, clean handovers, build next vehicle properly.',
    icon: 'ArrowRightCircle',
    outcomes: [
      'Income restructure',
      'Clean transition',
      'Next venture setup',
      'Exit strategy'
    ]
  }
];

export const problems = [
  {
    problem: 'Stuck at €10k-€200k/month',
    solution: 'Cannot scale cleanly'
  },
  {
    problem: 'Bleeding money from refunds and warranties',
    solution: 'Fraud and inefficiency'
  },
  {
    problem: 'Have capital, no execution clarity',
    solution: 'Need operator guidance'
  },
  {
    problem: 'Business looks fine, feels chaotic',
    solution: 'Hidden operational issues'
  },
  {
    problem: 'Starting from zero',
    solution: 'Need startup guidance and structure'
  },
  {
    problem: 'About to raise, expand, or pivot',
    solution: 'Need solid foundation'
  }
];

export const credentials = [
  {
    stat: '€50m+',
    label: 'Business volume last 2 years'
  },
  {
    stat: '13+',
    label: 'Years in the industry'
  },
  {
    stat: 'Global',
    label: 'Sourcing across 6+ countries'
  },
  {
    stat: 'Thousands',
    label: 'Devices moved weekly'
  }
];

export const expertise = [
  'Circular economy & ITAD (IT Asset Disposition) expertise',
  'Wholesale operations & B2B relationships',
  'Direct telco partnerships & stock solutions',
  'Marketplace strategy (Amazon, Back Market, Refurbed)',
  'Multi-channel software platforms & integrations',
  'Fraud prevention & commission dispute resolution',
  'Global sourcing: EU, USA, Dubai, Singapore, China, Japan, Australia',
  'DHL & UPS relationships for shipping rates and insurance',
  'Supply chain & operational leakage prevention',
  'Stock financing, cashflow management',
  'Team management: ops, logistics, QC, sales',
  'Startup support: building from zero to scale',
  'Career progression: shop floor to technician to sales manager to operator'
];

export const founderBio = {
  name: 'Sean Gavin',
  title: 'Founder',
  bio: 'Sean has done business of €50m+ across the last two years. He has run real operations, dealing with fraud, refunds, warranties, chargebacks, marketplace disputes, and operational chaos at scale. Strategic partner with Refurbed. Former top-tier Back Market seller who left due to platform fraud and commission misbehaviours. Re-Surge exists because Sean saw the same failures repeatedly in other businesses and knows how to fix them.',
  experience: '13+ years across tech resale, wholesale, and marketplace operations. Global sourcing experience spanning EU, USA, Dubai, Singapore, China, Japan, and Australia.'
};